import type { CostCode } from '../lib/costcodes';
import { codeLabel, codeOf, codeOptions } from '../lib/costcodes';

/**
 * The cost code picker — the timesheet's Cost code column, the employee card's
 * tile, each plant on Diesel, and the misc expense. One component so the four
 * offer the same list the same way: the active codes, plus a removed one the
 * row already carries, and "No cost code".
 *
 * `usual` is the employee's or the plant's own code. When the day's differs,
 * the line under the box says so — "usually CC-03" — so a change made for one
 * day is never mistaken for his normal work.
 */

interface Props {
  codes: CostCode[];
  value: string | null | undefined;
  usual?: string | null | undefined;
  disabled?: boolean;
  /** Short labels (the code alone) in the table, where the column is narrow. */
  compact?: boolean;
  className?: string;
  id?: string;
  onChange: (costCodeId: string | null) => void;
}

export default function CostCodeSelect({
  codes, value, usual, disabled, compact, className, id, onChange,
}: Props) {
  const changed = usual !== undefined && (usual ?? null) !== (value ?? null);
  return (
    <>
      <select
        id={id}
        className={className}
        aria-label="Cost code"
        value={value ?? ''}
        disabled={disabled}
        onChange={(e) => onChange(e.target.value === '' ? null : e.target.value)}
      >
        <option value="">{compact ? '—' : 'No cost code'}</option>
        {codeOptions(codes, value).map((code) => (
          <option key={code.id} value={code.id}>
            {compact ? code.code : codeLabel(code)}
          </option>
        ))}
      </select>
      {changed && (
        <div className="why" style={{ color: 'var(--text-warning)' }}>
          {usual ? `usually ${codeOf(codes, usual) || 'another code'}` : 'usually none'}
        </div>
      )}
    </>
  );
}
